export { default as ListaView } from './components/lista';



// WEBPACK FOOTER //
// src/modules/gruposSolicitudes/component.js